import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dropdown } from '@flywire/react-headlessui';
import { cx } from '../../utils';
const useItemClasses = ({ className }) => {
    return cx('block py-2.5 px-5 text-sm hover:bg-gray-50 text-gray-950', 'data-[focus=true]:bg-gray-50 data-[focus=true]:md:bg-gray-100', 'data-[pointer-disabled=true]:pointer-events-none', className);
};
const ItemComponent = forwardRef(({ className, ...rest }, ref) => {
    const ItemClasses = useItemClasses({ className });
    return _jsx(Dropdown.Item, { className: ItemClasses, ref: ref, ...rest });
});
ItemComponent.displayName = 'Item';
const Item = ItemComponent;
export { Item };
//# sourceMappingURL=Item.js.map